import * as utils from '@utils/form';
import { SLUG_RULE, TITLE_RULE } from '@constants';

export const FORM_FIELD = {
  PARENT_CHAPTER: {
    name: 'parentChapter',
    label: 'Parent chapter:',
    itemType: 'chapter',
    placeholder: 'Type to search a chapter',
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.makeRelatedEntityDeserializer(['id', 'title']),
    deserializeError: utils.deserializeErrorRelatedField,
    rules: [{ required: true, message: 'Parent chapter is required' }],
  },
  TITLE: {
    name: 'title',
    label: 'Title:',
    rules: [{ required: true, message: 'Title is required' }, TITLE_RULE],
  },
  SLUG: {
    name: 'slug',
    label: 'Slug:',
    rules: [{ required: true, message: 'Page slug is required' }, SLUG_RULE],
  },
  SEO_DESCRIPTION: {
    name: 'seoDescription',
    label: 'SEO description:',
  },
  TEXT: {
    name: 'text',
    label: 'Text:',
  },
  RULES: {
    name: 'rules',
    // TODO: change to default related entity serializer
    serialize: (field, values) => {
      const value = (values[field.name] ?? []).map((item) => ({ id: item.id, title: item.text }));
      return { [field.name]: value };
    },
  },
};

export const FORM_FIELDS = Object.values(FORM_FIELD);

export const DEFAULT_VALUES = {
  [FORM_FIELD.RULES.name]: [],
};
